export enum Action {
	SUGGEST = 'SUGGEST',
	ACCEPT = 'ACCEPT',
	REJECT = 'REJECT',
}

export enum EXTERNAL_PRODUCT_CONNECTION {
	LOOM = 'loom',
	MICROSOFT_TEAMS = 'teams',
	GOOGLE_DRIVE = 'gdrive',
}

export type Suggestion = {
	// ARI of a remote object, remote object is a 3P content
	id: string;
	title: string;
	description?: string;
	url: string;
	parentId: number;
	action: Action;
};

export type SuggestionGroup = {
	parentId: number;
	remoteObjects: Suggestion[];
};

export type SuggestionProductKey =
	| 'googleDocs'
	| 'googleSheets'
	| 'googleSlides'
	| 'googleDrive'
	| 'loom'
	| 'figma'
	| 'slack'
	| 'link';

export const PRODUCT_ICON_MAP: Array<{
	pattern: string;
	product: string;
	productKey: Exclude<SuggestionProductKey, 'link'>;
	iconUrl: string;
}> = [
	{
		pattern: 'docs.google.com/document',
		product: 'Google Docs',
		productKey: 'googleDocs',
		iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
	},
	{
		pattern: 'docs.google.com/spreadsheets',
		product: 'Google Sheets',
		productKey: 'googleSheets',
		iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png',
	},
	{
		pattern: 'docs.google.com/presentation',
		product: 'Google Slides',
		productKey: 'googleSlides',
		iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico',
	},
	{
		pattern: 'drive.google.com',
		product: 'Google Drive',
		productKey: 'googleDrive',
		iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
	},
	{
		pattern: 'loom.com',
		product: 'Loom',
		productKey: 'loom',
		iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico',
	},
	{
		pattern: 'figma.com',
		product: 'Figma',
		productKey: 'figma',
		iconUrl: 'https://static.figma.com/app/icon/1/favicon.ico',
	},
	{
		pattern: 'slack.com',
		product: 'Slack',
		productKey: 'slack',
		iconUrl: 'https://slack.com/favicon.ico',
	},
];

export const DEFAULT_PRODUCT_INFO: {
	productKey: SuggestionProductKey;
	iconUrl: string;
} = {
	productKey: 'link',
	iconUrl: '',
};
